<template>
  <div class="count-down-box">
    <span>考试倒计时:</span>
    <div class="count-time">
      <span>{{ hour }}</span>
      <span class="ml5 mr5">:</span>
      <span>{{ minute }}</span>
      <span class="ml5 mr5">:</span>
      <span>{{ second }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  props: {
    limitTime: {
      type: Number,
      default: 60
    },
  },
  data: () => {
    return {
      hour: '01',
      minute: '00',
      second: '00',
      timer: null
    }
  },
  created() {
    this.initTime()
    this.startTime()
  },
  methods: {
    //格式化
    initTime() {
      let hour = parseFloat(this.limitTime) / 60 % 24;
      let minute = this.limitTime - hour * 60;
      this.hour =  hour < 10 ? '0' + hour : hour;
      this.minute = minute < 10 ? '0' + minute : minute;
      this.second = '00'
    },
    //启动计时器
    startTime() {
      let second = this.limitTime * 60;
      this.timer = setInterval(() => {
        if (second <= 0) {
          clearInterval(this.timer)
          this.timer = null
          this.$emit('commit')//发生事件
        }
        second--;
        let hour = second / 60 / 60 % 24
        let minute =  parseInt( second / 60 % 60)
        this.hour =  hour < 1 ? '00' : hour < 10 ? '0' + hour : hour;
        this.minute = minute < 1 ? '00' : minute < 10 ? '0' + minute : minute;
        this.second = second % 60;
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.count-down-box {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0em;
  color: #409eff;
  font-size: 1.1em;
  background: #ecf5ff;
  padding: .5em 2em;
  letter-spacing: 2px;
  z-index: 9999999999999;

  .count-time {
    display: flex;
    align-items: center;
    margin-left: 1em;

    span {
      font-weight: bold;
    }
  }
}

</style>
